import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaSpinner, FaExclamationTriangle, FaArrowLeft } from "react-icons/fa";
import api from "../api/Api"; // Adjust path to your axios instance

export default function RetryPayment() {
    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const queryParams = new URLSearchParams(location.search);
    const oldTxnid = queryParams.get("txnid");

    useEffect(() => {
        if (!oldTxnid) {
            setError("Invalid transaction ID. Cannot retry payment.");
            setLoading(false);
            return;
        }

        const initiateRetry = async () => {
            try {
                const token = localStorage.getItem("token");
                const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

                // Call the backend to get fresh PayU data
                const response = await api.post("/bookingRoutes/retry-payment", { oldTxnid }, config);

                if (response?.data?.success && response.data.payuUrl) {
                    const { payuUrl, paymentData } = response.data;

                    // Create and submit the hidden form to PayU
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = payuUrl;

                    for (let key in paymentData) {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = key;
                        input.value = paymentData[key];
                        form.appendChild(input);
                    }

                    document.body.appendChild(form);
                    form.submit();
                } else {
                    setError("Failed to generate payment data. Please try again later.");
                    setLoading(false);
                }
            } catch (err) {
                setError(err?.response?.data?.message || "Something went wrong while contacting the server.");
                setLoading(false);
            }
        };

        initiateRetry();
    }, [oldTxnid]);

    return (
        <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light font-sans px-3">
            <div className="card border-0 shadow-lg rounded-4 p-4 text-center w-100" style={{ maxWidth: "400px" }}>
                {loading ? (
                    <>
                        <FaSpinner className="fa-spin text-primary mb-3" size={40} />
                        <h5 className="fw-bold text-dark">Retrying Payment...</h5>
                        <p className="text-muted small mb-0">Please wait while we redirect you securely to PayU.</p>
                    </>
                ) : (
                    <>
                        <FaExclamationTriangle className="text-danger mb-3" size={40} />
                        <h5 className="fw-bold text-dark mb-2">Retry Failed</h5>
                        <p className="text-muted small mb-4">{error}</p>
                        <button
                            onClick={() => navigate("/dashboard")}
                            className="btn btn-dark w-100 rounded-pill fw-bold py-2 d-flex align-items-center justify-content-center gap-2"
                        >
                            <FaArrowLeft /> Back to Home
                        </button>
                    </>
                )}
            </div>

            <style>{`
                .fa-spin { animation: spin 1s infinite linear; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
}